import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux'

// routes
import { Router } from './routes/sections'
// import ThemeCustomization from './theme';
// import GlobalStyles from './theme/globalStyles';

// theme
import { ThemeProvider } from './theme/theme-provider';

// actions
import { user } from './api/auth';

// state
import { setLoginStatusSlice } from './store/authSlice'
import { setUserStatusSlice } from './store/userSlice';

// import logo from './logo.svg';
import './App.css';

function App() {
  const Routing = Router()
  const dispatch = useDispatch()

  useEffect(() => {
    user().then((res) => { 
      if (res.status === 'success'){
        //@ts-ignore
        dispatch(setLoginStatusSlice(true))
        //@ts-ignore
        dispatch(setUserStatusSlice(res.user))
      }
    })
  }, []);

  return (
    <ThemeProvider>
      <Router />
    </ThemeProvider>
  );
}

export default App;
